import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../images/Logo.png';
import KnowYourselfConnectImage from '../images/KnowYourselfConnect.jpeg';
import '../styles/template.css';

const ConnectPage = () => {
  return (
    <div className="container">
      <header>
        <div className="logo-container">
          <img src={Logo} alt="Logo" className="logo" />
        </div>
        <h1>Meetups</h1>
        <nav>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/partners">Partners</Link></li>
            <li><Link to="/connect">Meetups</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </nav>
      </header>
      <main>
        <section className="connect-hero">
          <h2>Meet People Who Think Like You</h2>
          <img
            src={KnowYourselfConnectImage}
            alt="Know Yourself Connect - People meeting up"
            style={{
              maxWidth: "100%",   // responsive scaling
              height: "auto",     // keeps aspect ratio
              display: "block",   // avoids inline spacing issues
              margin: "0 auto",   // centers the image
              width: "90%"        // scales down from full size
            }}
          />
        </section>
        <section className="connect-content">
          <div className="connect-description">
            <p>
              Stop exploring alone. Create meetups at your favorite destinations or join ones 
              that match your interests. Connect with people who share your thinking style and 
              discover LA together.
            </p>
          </div>
          <div className="connect-features">
            <div className="feature-card">
              <h3>📍 Plan Meetups</h3>
              <p>Pick a destination, set a time, and invite others to join your adventure.</p>
            </div>
            <div className="feature-card">
              <h3>🤝 Find Your People</h3>
              <p>Meet others who match your intelligence type and share your interests.</p>
            </div>
            <div className="feature-card">
              <h3>💬 Chat & Coordinate</h3>
              <p>Group chat makes it easy to plan details and get to know attendees before you meet.</p>
            </div>
          </div>
          <div className="connect-cta">
            <h3>Ready to Connect?</h3>
            <p>Download the Know Yourself app to start creating and joining meetups.</p>
          </div>
        </section>
      </main>
      <footer>
        <p>&copy; 2026 Know Yourself LLC | All rights reserved.</p>
      </footer>
    </div>
  );
};

export default ConnectPage;
